/* @flow */

import hmacSHA1 from 'crypto-js/hmac-sha1';

import type { BO_API_AUTHENTICATION_SETTINGS } from '../types/AuthenticationSettings';
import type { BO_API_AUTHENTICATION_RESPONSE_CHALLENGE } from '../types/RequestResponseAuthenticate';

import { XhrResponseType } from '../../../../helpers/jsHelpers/xhr';
import { type CommonPromisedXMLHttpRequestReturnType, commonNetworkErrorCallBack, commonPromisedXMLHttpRequest } from '../../helpers/CommonPromisedXMLHttpRequest';
import { HeaderName, HeaderValue } from '../../v8/constants/Headers';
import { buildHeaderList } from '../../v8/helpers/RequestHeaders';
import { HttpMethod } from '../../v8/types/HttpMethod';

const authenticationRequest: (authenticationUrl: string, applicationId: string, deviceKey: string, appKey: string, signal?: AbortSignal) => Promise<BO_API_AUTHENTICATION_SETTINGS> = (
  authenticationUrl,
  applicationId,
  deviceKey,
  appKey,
  signal,
) => {
  const returnChallengeObject: CommonPromisedXMLHttpRequestReturnType = commonPromisedXMLHttpRequest(
    authenticationUrl,
    HttpMethod.POST,
    XhrResponseType.Json,
    buildHeaderList(HeaderName.ContentType, HeaderValue.ApplicationFormUrlencoded, HeaderName.AppKey, appKey),
    `app_id=${applicationId}`,
    null,
    false,
    commonNetworkErrorCallBack,
    signal,
  );

  return returnChallengeObject.promise.then((jsonChallengeResponse: BO_API_AUTHENTICATION_RESPONSE_CHALLENGE) => {
    const hmac = hmacSHA1(jsonChallengeResponse.challenge, deviceKey).toString();
    const returnAuthenticationObject: CommonPromisedXMLHttpRequestReturnType = commonPromisedXMLHttpRequest(
      authenticationUrl,
      HttpMethod.POST,
      XhrResponseType.Json,
      buildHeaderList(HeaderName.ContentType, HeaderValue.ApplicationFormUrlencoded, HeaderName.AppKey, appKey),
      `app_id=${applicationId}&hmac=${hmac}`,
      null,
      false,
      commonNetworkErrorCallBack,
      signal,
    );

    return returnAuthenticationObject.promise;
  });
};

export default authenticationRequest;
